import { NgModule, LOCALE_ID } from '@angular/core';

/** MODULES */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatCardModule } from '@angular/material/card';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from "@angular/material/dialog";
import { SidebarModule } from 'ng-sidebar';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { ToastrModule } from 'ngx-toastr';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

/** COMPONENTS */
import { AppComponent } from './app.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { NavbarComponent } from './navbar/navbar.component';

/** SERVICES */
import { UserService } from './services/user.service';
import { LoginService } from './services/login.service';
import { StorageService } from './services/storage.service';
import { SharedService } from './services/shared.service';
import { AuthInterceptorProvider } from './interceptors/auth-interceptor';
import { CustumersService } from './services/custumers.service';
import { CityService } from './services/city.service';
import { ProductService } from './services/product.service';
import { PhoneService } from './services/phone.service';
import { SectorService } from './services/Sector.service';
import { EquipmentService } from './services/equipment.service';
import { CorrectionsService } from './services/corrections.service';

/** LOCALE */
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { MessageService } from './services/message.service';
import { ReportService } from './services/report.service';
import { ErrorInterceptorProvider } from './interceptors/error-interceptor';
import { VisitsService } from './services/visits.service';
registerLocaleData(localePt);

@NgModule({
  declarations: [
    AppComponent,
    SidebarComponent,
    NavbarComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    SidebarModule.forRoot(),
    
    MatToolbarModule,
    MatCardModule,
    MatSidenavModule,
    MatButtonModule,
    MatDialogModule,
    AppRoutingModule,
    NgbModule,
    ToastrModule.forRoot({
      timeOut: 4000
    })
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    AuthInterceptorProvider,
    ErrorInterceptorProvider,
    LoginService,
    StorageService,
    SharedService,
    UserService,
    CustumersService,
    CityService,
    ProductService,
    PhoneService,
    SectorService,
    EquipmentService,
    CorrectionsService,
    MessageService,
    ReportService,
    VisitsService
  ],
  bootstrap: [
    AppComponent
  ]
})
export class AppModule { }
